import React, { useState, useEffect } from "react";

const CustomCircularProgress = ({
  size = 120,
  strokeWidth = 16,
  percentage = 98,
  trailColor = "#1675ff",
  strokeColor = "#1675ff",
  textColor = "white",
  textFamily = "Figtree",
  textSize = "1.5rem",
  textWeight = "500",
  mode = "light",
}) => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    setProgress(percentage);
  }, [percentage]);

  const viewBox = `0 0 ${size} ${size}`;
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * Math.PI * 2;
  const dash = (progress * circumference) / 100;

  return (
    <>
      <svg width={size} height={size} viewBox={viewBox}>
        <circle fill="none" stroke={trailColor} cx={size / 2} cy={size / 2} r={radius} strokeWidth={`${strokeWidth}px`} />
        <circle
          fill="none"
          stroke={strokeColor}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={`${strokeWidth}px`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          strokeDasharray={[dash, circumference - dash]}
          strokeLinecap="butt"
          style={{ transition: "all 0.5s" }}
        />
        <text
          fill={mode === "light" ? "#181818" : "rgba(255,255,255)"}
          fontFamily={textFamily}
          fontSize={textSize}
          fontWeight={textWeight}
          x="50%"
          y="50%"
          dy="0.4rem"
          textAnchor="middle"
        >
          {`${percentage}%`}
        </text>
      </svg>
    </>
  );
};

export default CustomCircularProgress;
